function getFlagEmoji(countryCode) {
  return countryCode.toUpperCase().split("").map((char) => String.fromCodePoint(127397 + char.charCodeAt(0))).join("");
}
const softRedirects = {
  PT: { url: "https://pitviper.es", countryName: "Portugal" },
  AD: { url: "https://pitviper.es", countryName: "Andorra" },
  GB: { url: "https://pitviper.co.uk", countryName: "United Kingdom" },
  NZ: { url: "https://pitviper.co.nz", countryName: "New Zealand" },
  CH: { url: "https://pitviper.ch", countryName: "Switzerland" },
  ZA: { url: "https://za.pitviper.com", countryName: "South Africa" }
};
const createButton = (text, classes, onClick) => {
  const button = document.createElement("button");
  button.classList.add(...classes);
  const rectangle = document.createElement("div");
  const buttonText = document.createElement("div");
  rectangle.classList.add("rectangle-1");
  buttonText.classList.add("button-text");
  buttonText.textContent = text;
  button.appendChild(rectangle);
  button.appendChild(buttonText);
  if (onClick) button.addEventListener("click", onClick);
  return button;
};
const showSoftRedirectModal = (modal, modalContent, modalFormContainer, modalMessageEl, countryCode, countryName) => {
  const initialMessage = modalMessageEl.innerHTML;
  modalFormContainer.style.display = "none";
  const buttonContainer = document.createElement("div");
  buttonContainer.classList.add("w-8/12", "mx-auto", "pb-8", "flex", "flex-col", "gap-4");
  modalMessageEl.innerHTML = `We see that you're in <strong>${countryName}</strong>. <br/>Shop your local storefront:`;
  const redirectButton = document.createElement("a");
  redirectButton.href = softRedirects[countryCode].url;
  redirectButton.target = "_blank";
  redirectButton.rel = "noopener noreferrer";
  redirectButton.classList.add("button", "button--primary", "min-w-22.5", "min-h-10", "max-h-10", "w-full", "mt-4");
  redirectButton.appendChild(createButton(`${getFlagEmoji(countryCode)} Go to ${countryName}`, [], () => {
  }));
  const stayButton = createButton("Stay Here", ["button", "button--secondary", "min-w-22.5", "min-h-10", "max-h-10"], () => {
    if (modal && modalContent) {
      document.body.classList.remove("overflow-hidden");
      modalContent.classList.remove("scale-in");
      modalContent.classList.add("scale-out");
      setTimeout(() => {
        if (modal) {
          modal.classList.add("hidden");
          modal.classList.remove("flex");
          modalFormContainer.style.display = "block";
          modalMessageEl.innerHTML = initialMessage;
          buttonContainer.remove();
        }
      }, 300);
    }
  });
  buttonContainer.appendChild(redirectButton);
  buttonContainer.appendChild(stayButton);
  modalFormContainer.parentNode?.insertBefore(buttonContainer, modalFormContainer);
  modal.classList.remove("hidden");
  modal.classList.add("flex");
};
function getCookie(name) {
  const cookies = document.cookie.split("; ");
  for (const cookie of cookies) {
    const [cookieName, cookieValue] = cookie.split("=");
    if (cookieName === name) {
      return decodeURIComponent(cookieValue);
    }
  }
  return null;
}
(async function handleLocalization() {
  try {
    const countryCode = getCookie("localization");
    if (softRedirects[countryCode]) {
      const countryName = softRedirects[countryCode].countryName;
      const modal = document.querySelector("[data-localization]");
      const modalContent = document.querySelector("[data-localization-content]");
      const modalFormContainer = document.querySelector("[data-localization-form-container]");
      const modalMessageEl = document.querySelector("[data-localization-message]");
      if (modal && modalContent && modalFormContainer && modalMessageEl && countryCode) {
        showSoftRedirectModal(modal, modalContent, modalFormContainer, modalMessageEl, countryCode, countryName);
      }
    }
  } catch (error) {
    console.error("Geolocation API error:", error);
  }
})();
